export default function (param) {

    var token="";
    if (window.localStorage.accessToken) {
        token = window.localStorage.accessToken
    }
    return token
}

